// компонент для отображения сообщения об отсутствии данных
export function NoData({text = "Данные отсутствуют"}) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <h3>{text}</h3>
      </div>
    );
  }